import DataObjectIcon from '@mui/icons-material/DataObject'
import { ActionCopyItem } from '@/components/table/actions/ActionCopyItem/ActionCopyItem'

type Props<T extends Record<string, unknown>> = {
  getValueToCopy: (row: T) => Promise<string> | string
  displaySeparately?: boolean
}

export const ActionCopyJSONItem = <T extends Record<string, unknown>>({
  getValueToCopy,
  displaySeparately
}: Props<T>) => (
  <ActionCopyItem
    getValueToCopy={getValueToCopy}
    successMessage="JSON copied to clipboard"
    errorMessage="Failed to copy JSON"
    overrideText="Copy JSON"
    icon={<DataObjectIcon />}
    displaySeparately={displaySeparately}
  />
)
